import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {
  DataRefresh,
  // Error,
  LogoutView,
  StyleGuide,
  // UserNotFound
} from 'common/pages';
import { NotFound } from 'common/navigation';
import React, { useEffect, useState } from 'react';
import { TAPRouterConfig } from 'TAP/navigation';
import { CustomErrorPage } from '../../common/pages/customErrorPage';
import { labels } from 'common/global/constants';
import { useMsal } from '@azure/msal-react';
import ReactGA from 'react-ga4';
import {
  getGAMeasurementId,
  isTimeOfRunningCDCPipeline,
  getUserAgentBrowser,
  getUserAgentOS,
} from 'TAP/utils/commonMethods';
import { TapGlobalMessages } from 'TAP/global';
import { TransferUniversalDashboardData } from 'TAP/redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { DASHBOARD_DATA_ACCEPTABLE_STATUSES } from 'common/global/constants';

export const RouterConfig = () => {
  let { instance } = useMsal();
  const dispatch = useDispatch();
  const logInUserDetails = JSON.parse(localStorage.getItem('userDetails'));
  const loggedInUserEmail = logInUserDetails?.user_email ?? null;
  const isUniversalDashboardDataTransfered = useSelector(
    (state) => state?.universalDashboardReducer?.isUniversalDashboardDataTransfered,
  );
  const [logoutDashboardEventRegistered, setLogoutDashboardEventRegistered] = useState(false);

  useEffect(() => {
    if (
      logoutDashboardEventRegistered &&
      DASHBOARD_DATA_ACCEPTABLE_STATUSES.includes(isUniversalDashboardDataTransfered)
    ) {
      setLogoutDashboardEventRegistered(false);
      handleLogoutUser();
    }
  }, [logoutDashboardEventRegistered, isUniversalDashboardDataTransfered]);

  const handleLogoutUser = () => {
    localStorage.clear();
    instance.logout();
  };

  const [pageExitDashboardEventRegistered, setPageExitDashboardEventRegistered] = useState(false);
  const recordPageExitEvent = () => {
    const currLogInUserDetails = JSON.parse(localStorage.getItem('userDetails'));
    setPageExitDashboardEventRegistered(true);
    dispatch(
      TransferUniversalDashboardData({
        apiType: 'page_exit',
        apiSubType: '',
        userEmailId: currLogInUserDetails?.user_email,
        pageTitle: currLogInUserDetails?.pageTitle ?? null,
        pageSubTitle: currLogInUserDetails?.pageSubTitle ?? null,
        pageURL: window.location.href,
        appName: process.env.REACT_APP_NAME,
        targetUrl: 'pagevisit/entry',
        ipAddress: null,
        idSession: currLogInUserDetails?.idSession ?? null,
        browser: getUserAgentBrowser(),
        os: getUserAgentOS(),
        visitStartTime: currLogInUserDetails?.visitStartTime ?? null,
        visitEndTime: new Date().toISOString('en-US', { timeZone: 'UTC' }),
        id: currLogInUserDetails?.id ?? null,
      }),
    );
  };
  useEffect(() => {
    if (
      pageExitDashboardEventRegistered &&
      DASHBOARD_DATA_ACCEPTABLE_STATUSES.includes(isUniversalDashboardDataTransfered)
    ) {
      setPageExitDashboardEventRegistered(false);
      recordLogoutEvent();
    }
  }, [pageExitDashboardEventRegistered, isUniversalDashboardDataTransfered]);
  const recordLogoutEvent = () => {
    setLogoutDashboardEventRegistered(true);
    dispatch(
      TransferUniversalDashboardData({
        apiType: 'user_session_logout_routerconfig',
        apiSubType: '',
        userEmailId: loggedInUserEmail,
        appName: process.env.REACT_APP_NAME,
        targetUrl: 'session',
        startDateTime: logInUserDetails?.loggedInTime,
        endDateTime: new Date().toISOString('en-US', { timeZone: 'UTC' }),
        ipAddress: null,
        idSession: logInUserDetails?.idSession ?? null,
        browser: getUserAgentBrowser(),
        os: getUserAgentOS(),
      }),
    );
  };

  const navigateToDTH = () => {
    window.location = process.env.REACT_APP_REDIRECT_DTH;
  };

  const isMaintenanceTime = isTimeOfRunningCDCPipeline();

  useEffect(() => {
    const urlArray = window.location.href.split('/');
    if (urlArray[urlArray.length - 1] === 'unauthorized' && isMaintenanceTime) {
      ReactGA.initialize(`G-${getGAMeasurementId()}`);
      ReactGA.send({ hitType: 'pageview', page: '/maintainance', title: ' Under Maintainance' });
    }
  }, [window.location.href]);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<TAPRouterConfig />} />
        <Route index element={<TAPRouterConfig />} />
        <Route path='TAP/*' element={<TAPRouterConfig />} />
        <Route path='*' element={<NotFound />} />
        <Route path='logout' element={<LogoutView />} />
        <Route path='styleguide' element={<StyleGuide />} />
        <Route
          path='error'
          element={
            <CustomErrorPage
              header={labels.errorHeader}
              body={labels.errorBody}
              buttonText={labels.errorButtonText}
              isButtonVisible={true}
              buttonHandler={recordPageExitEvent}
              subHeader={labels.errorSubHeader}
            />
          }
        />
        <Route
          path='unauthorized'
          element={
            <CustomErrorPage
              header={
                isMaintenanceTime ? TapGlobalMessages.tapMaintenance : labels.unauthorizedHeader
              }
              body={isMaintenanceTime ? '' : labels.unauthorizedBody}
              buttonText={labels.unauthorizedButtonText}
              isButtonVisible={true}
              buttonHandler={navigateToDTH}
              subHeader={isMaintenanceTime ? TapGlobalMessages.siteWillBack : ''}
              isMaintenancePage={isMaintenanceTime}
            />
          }
        />
        <Route path='datarefresh' element={<DataRefresh />}></Route>
      </Routes>
    </BrowserRouter>
  );
};
